import { useRef } from 'react'

import { store } from '@/store/recommendation'
import { useStore } from '@nanostores/react'

import { CardCarousel } from '@/components/ui/molecules/card-carousel'
import { RecommendationClick } from '@/tracking/recommendation'
import type { IProduct } from '@/types/product'
import React from 'react'
import ProductsListItem from './products.list.item'

export default function ProductRecommendationList({ post }: { post: string }) {
  const courses = useStore(store.recommendations)
  const payment = useStore(store.payment)

  const ref = useRef<HTMLElement | null>(null)

  if (!courses?.length || !payment) return <></>

  const handleClick = (product: IProduct) => {
    RecommendationClick({
      Produto: product.name,
      ProdutoID: product._id,
      Tipo: 'Curso',
      Instituicao: product.institution,
      Post: post,
    })
  }

  const slideContent = {
    courses: (product: IProduct) => {
      return (
        <div
          className="pb-6 px-2 not-prose"
          onClick={() => handleClick(product)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') handleClick(product)
          }}
        >
          <ProductsListItem product={product} payment={payment} />
        </div>
      )
    },
  }

  return (
    <section className="scroll-mt-24 not-prose" ref={ref}>
      <h2 className="font-bold text-3xl mt-7">
        Confira os nossos cursos recomendados
      </h2>
      <CardCarousel
        elements={courses}
        id="_id"
        slideContent={slideContent.courses}
        className="not-prose lg:basis-1/2 xl:basis-1/2"
      />
    </section>
  )
}
